$ = jQuery;

function setupMaps() {
  $(".js-googlemap").each(function() {
    const $map = $(this);
    const lat = parseFloat($map.data("gmapsLat"));
    const lng = parseFloat($map.data("gmapsLng"));
    const zoom = parseInt($map.data("gmapsZoom"));
    const infoContent = $map.data("gmapsContent");

    const position = new google.maps.LatLng(lat, lng);

    const args = {
      zoom: zoom,
      center: position,
      mapTypeId: google.maps.MapTypeId.ROADMAP,
    };

    const map = new google.maps.Map($map[0], args);

    const marker = new google.maps.Marker({
      position: position,
      map: map,
    });

    if (infoContent) {
      const html = $("<div/>")
        .html(infoContent)
        .text();
      const infowindow = new google.maps.InfoWindow({
        content: `<div class="B-GoogleMaps__infoWindow">${html}</div>`,
      });

      marker.addListener("click", function() {
        infowindow.open(map, marker);
      });

      infowindow.open(map, marker);
    }
  });
}

export default () => {
  $(setupMaps);
};
